(function () {
  'use strict';
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var scope = event.target.closest && event.target.closest('[data-section-type="product"]');
    if (!scope) return;
    var plan = scope.querySelector('[name="selling_plan"]');
    if (plan && plan.value) return;
    var json = scope.querySelector('[data-lm-variant-prices]');
    if (!json) return;
    var values;
    try { values = JSON.parse(json.textContent)[String(variant.id)]; } catch (_) { return; }
    if (!values) return;
    queueMicrotask(function () {
      scope.querySelectorAll('[data-price-wrapper]').forEach(function (wrapper) {
        var price = wrapper.querySelector('[data-product-price]');
        var compare = wrapper.querySelector('[data-compare-price]');
        if (price) {
          price.textContent = values.price;
          price.classList.toggle('product__price--sale', Boolean(values.compare));
        }
        if (values.compare && !compare) {
          compare = document.createElement('span');
          compare.className = 'product__price--compare';
          compare.setAttribute('data-compare-price', '');
          wrapper.appendChild(compare);
        }
        if (compare) {
          compare.textContent = values.compare;
          compare.hidden = !values.compare;
          compare.style.display = values.compare ? '' : 'none';
          compare.classList.toggle('hide', !values.compare);
        }
      });
      scope.querySelectorAll('[data-lm-sticky-compare]').forEach(function (compare) {
        compare.textContent = values.compare;
        compare.hidden = !values.compare;
      });
    });
  });
}());
